import { render, staticRenderFns } from "./AdminFabbricatiIdStanzeIdView.vue?vue&type=template&id=513f00b2&"
import script from "./AdminFabbricatiIdStanzeIdView.vue?vue&type=script&lang=ts&"
export * from "./AdminFabbricatiIdStanzeIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports